<template>
    <div class="sidebar">
        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar" data-widget="treeview" role="menu" data-accordion="false">
                <TheNodeTreeMenu v-for="menu in treeData" :key="menu.id" :node="menu"></TheNodeTreeMenu>
            </ul>
        </nav>
    </div>
</template>

<script>
    import TheNodeTreeMenu from '@/components/dashboard/TheNodeTreeMenu.vue';

    export default {
        name: 'TheTreeMenu',
        props: {
            treeData: Object
        },
        components: {
            TheNodeTreeMenu
        },
        async mounted() {
        }
    };
</script>

<style></style>